/* Lorvé Studio — base.js
   Modules:
   - Splash gate (cookie-based, 1.5s photo-expand transition)
   - Mobile menu toggle
   - Scroll reveal observer
   - Cart count refresh
*/

(function () {
  'use strict';

  /* ==========================================================================
     Cookie helpers
     ========================================================================== */
  function setCookie(name, value, hours) {
    var d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name + '=') === 0) return c.substring(name.length + 1);
    }
    return null;
  }
  function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax';
  }

  /* ==========================================================================
     Splash gate
     - Only on home (data-splash present)
     - Hide if cookie 'lv_seen' exists
     - On Enter click: animate photo-expand, then hide splash
     ========================================================================== */
  function initSplash() {
    var splash = document.querySelector('[data-splash]');
    if (!splash) return;

    var hours = parseInt(splash.getAttribute('data-cookie-hours'), 10) || 24;
    var rememberVisitor = splash.getAttribute('data-remember-visitor') === 'true';

    // During design/testing we do not remember visitors, so the welcome page shows every visit.
    if (!rememberVisitor) {
      deleteCookie('lv_seen');
    } else if (getCookie('lv_seen')) {
      splash.parentNode.removeChild(splash);
      document.body.classList.remove('splash-active');
      return;
    }

    // Lock scroll while splash is up
    document.body.classList.add('splash-active');

    var enterBtn = splash.querySelector('[data-splash-enter]');
    if (!enterBtn) return;

    enterBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runEnterAnimation(splash, hours);
    });
  }

  function runEnterAnimation(splash, hours) {
    var photo = splash.querySelector('[data-splash-photo]');
    var overlay = splash.querySelector('[data-splash-overlay]');
    var top = splash.querySelector('[data-splash-top]');
    var bottom = splash.querySelector('[data-splash-bottom]');

    // Find target — the hero section in the shop
    var heroTarget = document.querySelector('[data-hero-target]');

    // Step 1 — fade out overlay text and trust strips (0–400ms)
    if (overlay) overlay.style.opacity = '0';
    if (top) top.style.opacity = '0';
    if (bottom) bottom.style.opacity = '0';

    // Step 2 — expand photo to fill viewport (400–1200ms)
    setTimeout(function () {
      splash.classList.add('is-expanding');
    }, 200);

    // Step 3 — fade splash out, reveal page beneath (1200–1500ms)
    setTimeout(function () {
      splash.classList.add('is-fading');
    }, 1100);

    // Step 4 — remove splash from DOM, optionally remember visitor
    setTimeout(function () {
      var rememberVisitor = splash.getAttribute('data-remember-visitor') === 'true';
      if (splash.parentNode) splash.parentNode.removeChild(splash);
      document.body.classList.remove('splash-active');
      if (rememberVisitor) {
        setCookie('lv_seen', '1', hours);
      } else {
        deleteCookie('lv_seen');
      }

      // Trigger reveal of hero element
      if (heroTarget) heroTarget.classList.add('is-visible');

      // Smooth scroll to top in case
      window.scrollTo({ top: 0, behavior: 'auto' });
    }, 1500);
  }

  /* ==========================================================================
     Mobile menu
     ========================================================================== */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    function open() {
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    var closeBtn = menu.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') close();
    });
  }

  /* ==========================================================================
     Scroll reveal
     ========================================================================== */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ==========================================================================
     Cart count refresh
     ========================================================================== */
  function initCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* silently ignore */ });
  }


  /* ==========================================================================
     Product variant selection
     ========================================================================== */
  function initProductVariants() {
    var form = document.querySelector('.product__form');
    var variantsEl = document.querySelector('[data-product-variants]');
    if (!form || !variantsEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent || '[]');
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    if (!idInput || !addButton) return;
    var moneyFormatEl = document.querySelector('[data-money-format]');
    var moneyFormat = '${{amount}}';
    if (moneyFormatEl) {
      try {
        moneyFormat = JSON.parse(moneyFormatEl.textContent || '"${{amount}}"');
      } catch (e) {
        moneyFormat = '${{amount}}';
      }
    }
    var priceCurrent = document.querySelector('[data-product-price-current]');
    var priceCompare = document.querySelector('[data-product-price-compare]');
    var buyboxPrice = document.querySelector('[data-product-buybox-price]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      var value = (Number(cents || 0) / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', value)
        .replace('{{ amount }}', value)
        .replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)))
        .replace('{{ amount_no_decimals }}', String(Math.round(Number(cents || 0) / 100)));
    }

    function getSelectedOptions() {
      var values = [];
      form.querySelectorAll('fieldset.product__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) values.push(checked.value);
      });
      return values;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        if (!variant.options || variant.options.length !== options.length) return false;
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (buyboxPrice) buyboxPrice.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(variant.compare_at_price);
        } else {
          priceCompare.hidden = true;
          priceCompare.textContent = '';
        }
      }
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Add to bag';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold out';
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) updateVariant();
    });
  }

  /* ==========================================================================
     Init
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', function () {
    initSplash();
    initMobileMenu();
    initReveal();
    initCartCount();
    initProductVariants();
  });

})();
